import { SimpleForm, TextInput, Button, SaveButton, email, maxLength, required } from "react-admin";
import { Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNotify, useRefresh } from "react-admin";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import { phoneValidator } from "utils/validations";
import { BuildingOrUniversityInput } from "../Partials/BuildingOrUniversityInput";
import { useNotifyError } from "utils/useNotifyError";

const UpdateContactForm = ({ record, setEditContactMode }) => {
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSave = async data => {
    const payload = {
      address: data.contact?.address,
      phoneNumber: data.contact?.phoneNumber,
      mobilePhoneNumber: data.contact?.mobilePhoneNumber,
      email: data.contact?.email,
      buildingId: data.contact?.buildingId,
      universityId: data.contact?.universityId,
    };

    try {
      await dataProvider.customRequest(specialistRequests.updateExamCommitteeContact(record.id), payload, "PUT");
      notify("Контактната информация е обновена успешно", { type: "success" });
      setEditContactMode(false);
      refresh();
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <SimpleForm
      toolbar={false}
      onSubmit={handleSave}
      defaultValues={record}
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="contact.address"
            label="Адрес"
            fullWidth
            validate={[required(), maxLength(500)]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="contact.email"
            label="Имейл"
            fullWidth
            validate={[required(), email(), maxLength(256)]}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="contact.phoneNumber"
            label="Телефон"
            fullWidth
            validate={[required(), phoneValidator, maxLength(50)]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="contact.mobilePhoneNumber"
            label="Мобилен телефон"
            fullWidth
            validate={[required(), phoneValidator, maxLength(50)]}
          />
        </Grid>
        <BuildingOrUniversityInput />
      </Grid>
      <Grid sx={{ display: "flex", gap: 3, mt: 2 }}>
        <Button
          variant="outlined"
          startIcon={<CloseIcon />}
          color="error"
          size="small"
          label="Откажи"
          onClick={() => setEditContactMode(false)}
        />
        <SaveButton
          label="Запази"
          size="small"
        />
      </Grid>
    </SimpleForm>
  );
};

export default UpdateContactForm;
